module.exports = __webpack_public_path__ + "img/rocking-chairs-03.c3f4990f.jpeg";